import { connectBaseApi, notificationClient, createRpcMutation } from "@racoon/api";

const notificationGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    notifyReceiverJobCompleted: createRpcMutation(
      build,
      notificationClient,
      "notifyReceiverJobCompleted",
      { invalidatesTags: ["Order"] },
    ),
  }),
  overrideExisting: false,
});

export const { useNotifyReceiverJobCompletedMutation } = notificationGrpc;
